define('app/sds/attributes/sds-attrbiutes',[],function () {

});
